<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { VideoBlock } from 'query-strapi-v4';
  import { cn } from '$lib/utils';
  import { onMount } from 'svelte';

  type Block = $$Generic<VideoBlock | undefined>;
  export let block = undefined as VideoBlock;

  const dispatch = createEventDispatcher<{
    'analytics-event': {
      name: 'Video';
      props: {
        Text: string;
        Src: string;
      };
    };
  }>();

  const file = block.media.data.attributes;
  const defaultImage = file;
  const poster = block.placeholder_image?.data.attributes.url ?? '';
  const caption = file.caption;

  let videoPlayer;
  let isPlaying = false;

  onMount(() => {});
  const playVideo = () => {
    videoPlayer?.play();
    isPlaying = true;
    dispatch('analytics-event', {
      name: 'Video',
      props: { Text: caption ?? file.alternativeText, Src: file.url }
    });
  };
</script>

{#if block.media}
  <div class="not-prose wrapper relative mb-6">
    <div class="wrapper relative">
      {#if !isPlaying}
        <div
          class={cn(
            {
              'bg-black/75': true
            },
            'flex justify-center items-center absolute inset-0 w-full h-full bg-black z-40'
          )}
        >
          <div class="text-center">
            <button
              on:click={playVideo}
              class="mx-auto border-2 border-white text-white rounded-full flex justify-center items-center transform hover:scale-105 w-16 h-16 md:w-24 md:h-24"
              ><!---->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-8 w-8 md:-mr-2 md:w-12 md:h-12"
                ><path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                /></svg
              ></button
            >
          </div>
        </div>
      {/if}
      <video
        bind:this={videoPlayer}
        preload="none"
        width="560"
        height="360"
        controls={true}
        class="max-w-full w-full"
        {poster}
      >
        <source src={defaultImage.url} type="video/mp4" />
        <track kind="captions" />
      </video>
    </div>
    {#if file.caption}
      <p class="text-sm italic text-center">{file.caption}</p>
    {/if}
  </div>
{:else}
  <p>Video not found</p>
{/if}
